import React from 'react'
import styled from '@emotion/styled'
const Icon = styled.svg`
  .cls-1 {
    fill: #fff;
  }
`

export const CarriersIcon = () => {
  return (
    <Icon viewBox="0 0 70 70">
      <g id="carriers_icon" data-name="carriers icon">
        <circle id="Oval-2" className="cls-1" cx="47.73" cy="7.95" r="4.77" />
        <circle
          id="Oval-2-Copy"
          className="cls-1"
          cx="60.45"
          cy="19.09"
          r="3"
        />
        <circle
          id="Oval-2-Copy-2"
          className="cls-1"
          cx="65.23"
          cy="36.59"
          r="3"
        />
        <circle
          id="Oval-2-Copy-4"
          className="cls-1"
          cx="60.45"
          cy="54.09"
          r="3"
        />
        <circle
          id="Oval-2-Copy-6"
          className="cls-1"
          cx="44.55"
          cy="65.23"
          r="3.2"
        />
        <circle
          id="Oval-2-Copy-8"
          className="cls-1"
          cx="27.05"
          cy="65.23"
          r="3.4"
        />
        <circle
          id="Oval-2-Copy-9"
          className="cls-1"
          cx="12.73"
          cy="57.27"
          r="3.6"
        />
        <circle
          id="Oval-2-Copy-10"
          className="cls-1"
          cx="4.77"
          cy="42.95"
          r="3.8"
        />
        <circle
          id="Oval-2-Copy-11"
          className="cls-1"
          cx="4.77"
          cy="25.45"
          r="4"
        />
        <circle
          id="Oval-2-Copy-13"
          className="cls-1"
          cx="14.32"
          cy="12.73"
          r="4.2"
        />
        <circle
          id="Oval-2-Copy-14"
          className="cls-1"
          cx="30.23"
          cy="4.77"
          r="4.5"
        />
      </g>
    </Icon>
  )
}
